<router-outlet></router-outlet>

<app-spiner></app-spiner>

<div class="overlay tr-3s" role="presentation"></div>
